export default __webpack_public_path__ + "static/media/logoMarisetaTShirt.06cfda54.svg";